import React, { useState, useEffect } from 'react'
import App from './App'
import ModalAlert from './shared/ModalAlert'
import Modal from './shared/Modal'
import Loader from './shared/Loader'
import { NO_IMAGE_SOURCE } from './shared/GlobalConstants'

export default function DeleteAccount({ appProps, screenClass, retrieveTenantsPath }) {
  const [loading, setLoading]                           = useState(false)
  const [deleteLoading, setDeleteLoading]               = useState(false)
  const [deleteAccountAlert, setDeleteAccountAlert]     = useState(false)
  const [storeToBeDeleted, setStoreToBeDeleted]         = useState(null)
  const [accountError, setAccountError]                 = useState(null)
  const [accountDeleteMessage, setAccountDeleteMessage] = useState(false)
  const [tenants, setTenants]                           = useState([])

  useEffect(()=> {
    setLoading(true)

    let formData = new FormData()
    formData.append('owners', true)

    Rails.ajax({
      type: 'POST',
      url: retrieveTenantsPath,
      data: formData,
      dataType: 'json',
      success: res => {
        setTenants(res.tenants)
        setLoading(false)
      }
    })
  }, [])

  function handleDeleteStore() {
    setDeleteLoading(true)

    let formData = new FormData()
    formData.append('tenant_uid', storeToBeDeleted.tenant_uid)
    formData.append('conn_app_uid', storeToBeDeleted.conn_app_uid)

    Rails.ajax({
      type: 'POST',
      url: appProps.deleteStoreAccountPath,
      dataType: 'json',
      data: formData,
      success: res => {
        setDeleteLoading(false)
        if (res.errors) {
          setAccountError(res.errors)
          setTimeout( ()=> {
            setAccountError(null)
          }, 5000)
        } else {
          setAccountDeleteMessage(true)
          setTimeout( ()=> {
            window.location.reload()
          }, 3000)
        }
      },
      complete: () => {
        setStoreToBeDeleted(null)
      }
    })
  }

  function handleDelete() {
    setDeleteLoading(true)

    Rails.ajax({
      type: 'POST',
      url: appProps.deleteAccountPath,
      dataType: 'json',
      success: res => {
        setDeleteLoading(false)
        if (res.errors) {
          setAccountError(res.errors)
          setTimeout( ()=> {
            setAccountError(null)
          }, 5000)
        } else {
          setAccountDeleteMessage(true)
          setTimeout( ()=> {
            window.location.reload()
          }, 3000)
        }
      },
      complete: () => {
        setDeleteAccountAlert(false)
      }
    })
  }

  function renderTenantCard(tenant, index) {
    const tenantTitle = tenant.application_name && tenant.application_name.length > 0 ? tenant.application_name : tenant.tenant_url
    const accessTypes = [tenant.is_user ? Cas.translations.tooltip_customer : null, tenant.is_admin ? Cas.translations.tooltip_admin : null].filter(t => t).join(', ')

    return (
      <div key={ index } className='delete-account-card'>
        <div className='delete-account-logo'>
          <img src={ tenant.logo ? tenant.logo : NO_IMAGE_SOURCE } />
        </div>
        <div className='delete-account-card-content'>
          <div className='delete-account-card-kicker'>{ Cas.translations.delete_account.owned_account }</div>
          <h3>{ tenantTitle }</h3>
          { tenant.is_admin &&
            <div className='delete-account-access'>
              <span>{ Cas.translations.your_access }</span>
              <strong>{ accessTypes }</strong>
            </div>
          }
        </div>
        <button
          type='button'
          className='delete-account-card-action'
          aria-label={ Cas.translations.delete_account.delete_connected_account }
          onClick={ () => setStoreToBeDeleted(tenant) }>
          <i className='fa-light fa-trash'></i>
        </button>
      </div>
    )
  }

  return (
    <App appProps={ appProps }>
      <div className={ `${screenClass}` }>
        { accountError &&
          <div className='delete-alert error'>
            <i className='fa-light fa-triangle-exclamation'></i>
            <div>
              <strong>{ Cas.translations.delete_account.error_title }</strong>
              <span>{ accountError }</span>
            </div>
          </div>
        }

        <section className='create-instance-hero delete-account-hero'>
          <div className='create-instance-hero-copy'>
            <div className='eyebrow'>{ Cas.translations.delete_account.eyebrow }</div>
            <h1>{ Cas.translations.sidenav_delete_account }</h1>
            <p>{ Cas.translations.delete_account.account_disclaimer_warning }</p>
          </div>
          <div className='delete-hero-card'>
            <i className='fa-light fa-shield-exclamation'></i>
            <div>
              <span>{ tenants.length }</span>
              <p>{ Cas.translations.delete_account.associated_accounts_found }</p>
            </div>
          </div>
        </section>

        <section className='create-instance-flow' aria-label={ Cas.translations.delete_account.flow_label }>
          <div className='flow-step active'>
            <i className='fa-light fa-link'></i>
            <span>{ Cas.translations.delete_account.associated_step }</span>
          </div>
          <div className='flow-line'></div>
          <div className='flow-step active'>
            <i className='fa-light fa-file-shield'></i>
            <span>{ Cas.translations.delete_account.review_step }</span>
          </div>
          <div className='flow-line'></div>
          <div className='flow-step'>
            <i className='fa-light fa-trash'></i>
            <span>{ Cas.translations.delete_account.delete_step }</span>
          </div>
        </section>

        <section className='create-instance-wrapper delete-account-shell'>
          <div className='section-heading'>
            <div>
              <div className='eyebrow'>{ Cas.translations.delete_account.overview_title }</div>
              <h2>{ Cas.translations.delete_account.linked_accounts_title }</h2>
            </div>
            <div className='availability-pill delete-count-pill'>
              <i className='fa-light fa-building-user'></i>
              <span>{ tenants.length }</span>
            </div>
          </div>

          <p className='delete-section-copy'>{ Cas.translations.delete_account.linked_accounts_description }</p>

          { loading ?
            <div className='delete-loading-panel'>
              <Loader size='medium' position='centered'/>
              <span>{ Cas.translations.delete_account.loading_accounts }</span>
            </div>
            :
            <>
              { tenants.length > 0 ?
                <div className='delete-account-grid'>
                  { tenants.map((tenant, index) => renderTenantCard(tenant, index)) }
                </div>
                :
                <div className='delete-empty-panel'>
                  <i className='fa-light fa-circle-info'></i>
                  <div>
                    <h3>{ Cas.translations.delete_account.no_accounts_title }</h3>
                    <p>{ Cas.translations.delete_account.no_accounts_description }</p>
                  </div>
                </div>
              }
            </>
          }

          <div className='delete-danger-panel'>
            <div>
              <div className='eyebrow'>{ Cas.translations.delete_account.final_action_title }</div>
              <h2>{ Cas.translations.delete_account.delete_my_data_action }</h2>
              <p>{ Cas.translations.delete_account.final_action_description }</p>
            </div>
            <button type='button' className='button delete-account-final-button' onClick={ ()=> setDeleteAccountAlert(true) }>
              <i className='fa-light fa-trash'></i>
              { Cas.translations.delete_account.delete_my_data_action }
            </button>
          </div>
        </section>
      </div>

      { deleteAccountAlert &&
        <ModalAlert
          alert={
            <div className='flex-box flex-column'>
              <div className='bold m-b-10'>
                { Cas.translations.delete_account.warning_message }
              </div>
              <div>
               { Cas.translations.delete_account.confirm_deletion_warning }
              </div>
            </div>
          }
          mode='medium'
          onSelect={ () => handleDelete() }
          onClose={ () => setDeleteAccountAlert(false) }
        />
      }

      { storeToBeDeleted &&
        <ModalAlert
          alert={
            <div className='flex-box flex-column'>
              <div className='bold m-b-10'>
                { Cas.translations.delete_account.warning_message }
              </div>
              <div>
                { Cas.translations.delete_account.confirm_store_deletion }
              </div>
            </div>
          }
          mode='medium'
          onSelect={ ()=> handleDeleteStore() }
          onClose={ () => setStoreToBeDeleted(null) }
        />
      }

      { deleteLoading &&
        <div className='delete-account-loader'>
          <Loader fullPage size='large' />
        </div>
      }

      { accountDeleteMessage &&
        <Modal
          visible={ true }
          mode={ 'small' }
          closeModal={ ()=> {} }>
          <div className='delete-success-message'>
            <i className='fa-light fa-circle-check'></i>
            <strong>{ Cas.translations.delete_account.success_title }</strong>
            <div>{ Cas.translations.delete_account.post_deletion_message }</div>
            <Loader size='medium' position='centered'/>
          </div>
        </Modal>
      }

    </App>
  )
}
